import { useTranslation } from 'react-i18next';
import { Typography, useTheme, Grid } from '@mui/material';
import RegulationAcceptance, {
  RegulationAcceptanceProps
} from 'pages/account/Register/pages/Main/steps/components/RegulationAcceptance';

import { IconInfo } from '../Icon';

const AcceptRegulationsWithInfoView = <T,>({
  ...formikProps
}: RegulationAcceptanceProps<T>) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Grid sx={{ pt: 3.5 }}>
      <Grid
        sx={{
          pb: 2,
          display: 'flex',
          alignItmes: 'center',
          flexDirection: 'row'
        }}
      >
        <Grid sx={{ pr: 2 }}>
          <Typography color={`${theme.customPalette.cobalt.primary}`}>
            <IconInfo sx={{ fontSize: 24 }} />
          </Typography>
        </Grid>
        <Grid>
          <Typography
            variant="subtitle1"
            color={`${theme.customPalette.cobalt.primary}`}
          >
            {t('FIRST_LOGIN_REGULATION_ACCEPTANCE')}
          </Typography>
        </Grid>
      </Grid>
      <RegulationAcceptance {...formikProps} />
    </Grid>
  );
};

export default AcceptRegulationsWithInfoView;
